/* Coordinated limb greetings and body sway; native buttons provide accessible replay. */
(() => {
  window.GrovaSections.register('grova-mascot', '[data-grova-mascot]', (root, scope) => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let running = false, disposed = false, entered = false, animations = [], observer;
    const seated = root.dataset.grovaMascot === 'seated';
    const rotations = seated
      ? { 'left-leg': [0, -34, 34, -28, 28, 0], 'right-leg': [0, 34, -34, 28, -28, 0] }
      : { forearm: [0, -35, 30, -35, 30, 0], hand: [0, -22, 28, -22, 28, 0] };
    function stop() {
      animations.forEach(animation => animation.cancel());
      animations = [];
      running = false;
    }
    function greet(interactive = false) {
      if (disposed || running || reduced.matches) return;
      running = true;
      animations = Object.entries(rotations).flatMap(([name, angles]) => {
        const limb = root.querySelector(`[data-mascot-limb="${name}"]`);
        if (!limb?.animate) return [];
        return [limb.animate(angles.map(angle => ({ transform: `rotate(${angle}deg)`, easing: 'ease-in-out' })), {
          duration: 2500, iterations: 1, fill: 'none',
        })];
      });
      // Move the complete canvas so the raster body and SVG attachment points stay joined.
      const figure = root.querySelector('svg');
      if ((!seated || interactive) && figure?.animate) {
        animations.push(figure.animate([0, -1, 1, -1, 1, 0].map(direction => ({
          transform: `translateX(${direction * 2}%) rotate(${direction * (seated ? 4 : 5)}deg)`,
          easing: 'ease-in-out',
        })), { duration: 2500, iterations: 1, fill: 'none' }));
      }
      const current = animations;
      Promise.allSettled(current.map(animation => animation.finished)).then(() => {
        if (animations === current) stop();
      });
    }
    scope.on(root, 'click', () => greet(true));
    scope.on(root, 'pointerenter', event => {
      if (event.pointerType === 'mouse' && hover.matches) greet(true);
    });
    scope.on(reduced, 'change', () => {
      if (reduced.matches) stop();
    });
    if (!root.hasAttribute('data-mascot-no-arrival') && window.IntersectionObserver) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) entered = false;
          if (entry.isIntersecting && entry.intersectionRatio >= .5 && !entered) {
            entered = true;
            greet(true);
          }
        });
      }, { threshold: [0, .5] });
      observer.observe(root);
    }
    scope.cleanup(() => { disposed = true; observer?.disconnect(); stop(); });
  });
})();
